import {NavButtonWithSize} from 'Event/Dashboard/components/NavButton'
import React from 'react'
import {UseFormMethods} from 'react-hook-form'
import Typography from 'Event/Dashboard/components/Sidebar/SidebarNavButtonConfig/Styling/Typography'
import Background from 'Event/Dashboard/components/Sidebar/SidebarNavButtonConfig/Styling/Background'
import Size from 'Event/Dashboard/components/Sidebar/SidebarNavButtonConfig/Styling/Size'
import Border from 'Event/Dashboard/components/Sidebar/SidebarNavButtonConfig/Styling/Border'

export default function BaseStyling(props: {
  control: UseFormMethods['control']
  watch: UseFormMethods['watch']
  button: NavButtonWithSize
}) {
  const {control, watch, button} = props

  return (
    <>
      <Typography control={control} button={button} />
      <Background control={control} button={button} watch={watch} />
      <Size button={button} control={control} />
      <Border control={control} button={button} />
    </>
  )
}
